import axios from 'axios'
import { useAdminStore } from '../../store/userStore'
import { swalAlert } from '../../utils/swal/swal'

const SERVER_URL = process.env.REACT_APP_SERVER_URL

export const adminApi = axios.create({
    baseURL: SERVER_URL + '/api/admin',
})

export const adminAuthApi = axios.create({
    baseURL: SERVER_URL + '/api/admin',
    withCredentials: true,
})

/* axios 인터셉터 - 토큰검증 및 요청재시도 */
let isRefreshing = false
adminAuthApi.interceptors.response.use(
    // 요청 성공
    (response) => {
        return response
    },

    // 요청 실패
    async (error) => {
        const originalRequest = error.config

        if (error.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true

            if (!isRefreshing) {
                isRefreshing = true

                try {
                    await axios.get(SERVER_URL + '/api/admin/auth/refresh', { withCredentials: true }) // refreshToken 검증

                    isRefreshing = false // isRefreshing 상태 토글

                    return adminAuthApi(originalRequest) // 요청 재시도

                } catch (refreshError) {

                    await axios.get(SERVER_URL + '/api/admin/auth/logout', { withCredentials: true }) // 백 로그아웃 - 토큰 삭제

                    const adminStoreState = useAdminStore.getState()
                    adminStoreState.adminLogoutAction() // 프론트 로그아웃 - 전역 상태 초기화
                    isRefreshing = false // isRefreshing 상태 토글

                    swalAlert('', '로그인 정보 보호를 위해 자동으로 로그아웃되었습니다.<br/> 다시 로그인 해주세요.', 'info', '확인', () => { window.location.href = '/hy-admin/login' })
                    return new Promise(() => { })

                    // return Promise.reject(new Error('Refresh token expired. Please log in again.'))

                }
            }
        }

        return Promise.reject(error)
    }
)
